import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TextBlock = makeShortcode("TextBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TextBlock slots="image, heading, text" width="33%" theme="light" className="creatorToolBox" mdxType="TextBlock" />
    <p><img parentName="p" {...{
        "src": "/express/add-ons/assets/619009764c0fd34731134a117a3e8e98/CodeAssist.svg",
        "alt": "Familiar web technology"
      }}></img></p>
    <h3 {...{
      "id": "familiar-web-technology"
    }}>{`Familiar Web Technology`}</h3>
    <p>{`Use HTML, CSS, JavaScript or TypeScript combined with Adobe's design system called `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/express/add-ons/docs/guides/build/design/"
      }}>{`Spectrum`}</a>{` to build native-feeling user experiences for your add-on.`}</p>
    <TextBlock slots="image, heading, text" width="33%" theme="light" className="creatorToolBox" mdxType="TextBlock" />
    <p><img parentName="p" {...{
        "src": "/express/add-ons/assets/aa862681e5dc012c1c1f3a85dcfa010a/AdobeExpress_EmbedSDK_Tools.svg",
        "alt": "Dedicated dev resources & tools"
      }}></img></p>
    <h3 {...{
      "id": "dedicated-dev-resources--tools"
    }}>{`Dedicated Dev Resources & Tools`}</h3>
    <p>{`Get started with built-in dev tools, libraries and add-samples. Try our `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/express/add-ons/docs/guides/getting_started/code_playground/"
      }}>{`Code Playground`}</a>{`—a lightweight code editor directly inside Adobe Express—without any set-up on your machine.`}</p>
    <TextBlock slots="image, heading, text" width="33%" theme="light" className="creatorToolBox" mdxType="TextBlock" />
    <p><img parentName="p" {...{
        "src": "/express/add-ons/assets/b5b5a1701e69bee6f2f67020b167ec4f/AdobeExpress_PluginAddOn.svg",
        "alt": "Powerful capabilities"
      }}></img></p>
    <h3 {...{
      "id": "powerful-capabilities"
    }}>{`Powerful Capabilities`}</h3>
    <p>{`From AI-driven add-ons enhancing user designs to innovative design effects, build custom workflows that can improve the lives of millions of creatives.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      